import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import Header from './Header';


/* 排行榜 */
class Rank extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ranks: [],
    };
  }

  componentDidMount() {
    let year = '';
    let month = '';
    let url = 'api/getrank/?';
    if (this.props.year !== '') {
      url = url + 'year=' + this.props.year;
    } 
    if (this.props.month !== '') {
      url = url + '&month=' + this.props.month;
    } 
    /*url = url + "/";*/
    
    fetch(URL + url,{
      headers: new Headers({
        'content-type': 'application/json'
      })
    })
    .then(res=>res.json())
    .then(res=>this.setState({ranks:res}))
  }  

  render() {
    let ranks = this.state.ranks;
    let rows = [];
    ranks.forEach(rank=>{
      rows.push(<tr key={rank.no}><td>{rank.no}</td><td>{rank.username}</td><td>{rank.count}</td></tr>)
    })
    return(
      <Table><tbody>
        <tr><th>#</th><th>User</th><th>Count</th></tr>
        {rows}
        </tbody></Table>
    )
  }
}


export default Rank;



// WEBPACK FOOTER //
// ./src/Rank.js